import React, { useContext, useState } from "react";
import { storeContext } from "./../../../../global/store";
import Switch from "react-switch";

const OverviewSection = () => {
  const { store, setStore } = useContext(storeContext);
  const [checked, setChecked] = useState(
    store.layout === "side" ? false : true,
  );

  const handleChange = (nextChecked) => {
    setChecked(nextChecked);
    setStore({ ...store, triggerAnimation: true });
    setTimeout(() => {
      setStore({ ...store, layout: "side" });
    }, 1100);
  };

  return (
    <section
      id="OverviewSection"
      className="mx-auto flex flex-col space-y-8 lg:space-y-0 items-center justify-center lg:justify-between px-4 py-10 md:py-24 lg:max-w-[1146px] lg:flex-row"
    >
      <div className="flex w-11/12 flex-col items-center justify-center space-x-2 lg:w-1/2 lg:max-w-[675px] lg:space-y-6">
        <div className="space-y-8 text-center xl:text-left">
          <h1 className="text-5xl leading-tight">
            Hi there <span>👋🏼</span> <span>👀</span> !
          </h1>
          <p className="text-sm font-normal leading-loose opacity-60">
            I'm Badreddin Labed, a Professional Senior Software Engineer who
            specializes in{" "}
            <span className=" underline decoration-2 decoration-[#000]">
              JavaScript & TypeScript
            </span>
            , I can help you solve a problem, build a product or grow an
            existing project.
          </p>
        </div>
        <label className="hidden self-start xl:flex flex-row items-center justify-center space-x-4 relative right-2">
          <span className="font-normal leading-loose opacity-60">Vertical</span>
          <Switch
            onChange={handleChange}
            checked={checked}
            onColor="#000000"
            className="react-switch"
            data-umami-event="switch-from-vertical"
          />
        </label>
      </div>
      <div className="flex flex-row items-center justify-center w-full lg:w-1/2">
        <div className="w-[400px] h-[400px] rounded-full avatar-image"></div>
      </div>
    </section>
  );
};

export default OverviewSection;
